import React from "react";
import { useLocation } from "react-router-dom";
import {
  PaymentMethod,
} from "../../types";
import { TotemTerminalPayment } from "./TotemTerminal";
import { PixTotemPayment } from "./PixTotem";
import { usePixEnabledGuard } from "../../hooks/usePixEnabledGuard";

export const VisitorConfirmPurchase: React.FC = () => {
  const {
    state: { paymentMethod },
  }: {
    state: {
      paymentMethod?: PaymentMethod;
    };
  } = useLocation();
  const isPixEnabledOnTotem = usePixEnabledGuard(
    "/visitor-purchase",
    paymentMethod === PaymentMethod.PIX
  );

  if (paymentMethod === PaymentMethod.CREDIT_CARD || paymentMethod === PaymentMethod.DEBIT_CARD) {
    return (
      <TotemTerminalPayment />
    );
  }
  if (paymentMethod === PaymentMethod.PIX && isPixEnabledOnTotem) {
    return (
      <PixTotemPayment />
    );
  }
  return <div />;
};
